import View from '../view.js';

class ServerTypeWarning extends View {
  get events() {
    let events = [];
    events[`change ${this.selector}`] = 'confirm';
    return events;
  }

  _ensureDefaultElement() {
    this._setElement('#main-content');
  }

  beforeFilter() {
    if (_.isEmpty(this.selector)) {
      throw new Error('You must specify a selector for ServerTypeWarning');
    }
    this.serverType = this.$(this.selector).val();
  }

  confirm(e) {
    let confirmationModal,
      msg =
        'Changing Type of Server may impact data to Payment Software and Redis Keys.<br>Would you like to proceed?';

    if (this.serverType == e.target.value) {
      return;
    }
    confirmationModal = new IO.Views.ConfirmationModal({
      el: '#confirmation-modal',
      closable: false,
    });

    confirmationModal.show(msg, (awnser) => {
      !awnser
        ? this.$(this.selector).val(this.serverType).trigger('change')
        : (this.serverType = e.target.value);
    });
  }
}

module.exports = ServerTypeWarning;
